// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__srl1o","checkboxCol":"Table_checkboxCol__1zwh3","emailCol":"Table_emailCol__TWY-2","actionCol":"Table_actionCol__X6zqq"};